<template>
  <div v-if="show">
    <el-form label-position="top">
      <el-form-item :label="'字段标识'" v-if="(data.type!='grid'&&data.type!='collapse')&& data.isTable ===false">
        <el-select v-model="data.model" placeholder="请选择" width="100%" size="small" @change="(val)=>
          {
          data.name=formkey.find(m=>m.key===val).description
          }">
          <!-- <el-input v-model="data.model" size="small" @change="(val)=>{data.model=val.substring(0, 1).toLowerCase() + val.substring(1)}"  ></el-input> -->
          <el-option v-for="(item,index) in formkey" :key="index" :label="item.description+'/'+item.key"
                     :value="item.key">
          </el-option>
        </el-select>
        <el-input v-model="data.model" size="small"
                  @change="(val)=>{data.model=val.substring(0, 1).toLowerCase() + val.substring(1)}"></el-input>
      </el-form-item>
      <el-form-item :label="'字段标识'" v-else-if="(data.type!='grid'&&data.type!='collapse')">

        <el-input v-model="data.model" size="small"
                  @change="(val)=>{data.model=val.substring(0, 1).toLowerCase() + val.substring(1)}"></el-input>

      </el-form-item>
      <el-form-item :label="'标题'" v-if="(data.type!='grid'&&data.type!='collapse')">

        <el-input v-model="data.name" size="small"></el-input>

      </el-form-item>

      <el-form-item :label="'默认值'" v-if="data.type=='selecType'">
        <el-input v-model="data.options.defaultValue" size="small"></el-input>
      </el-form-item>
      <el-form-item :label="'是否启用编辑'" v-if="data.type=='selecType'">
        <el-switch size="small" v-model="data.options.isEdit"></el-switch>
      </el-form-item>
      <el-form-item :label="'类型ID'" v-if="Object.keys(data.options).indexOf('typeId')>=0">
        <el-input v-model="data.options.typeId" size="small"></el-input>
      </el-form-item>
      <el-form-item :label="'宽度'" v-if="Object.keys(data.options).indexOf('width')>=0">
        <el-input v-model="data.options.width" size="small"></el-input>
      </el-form-item>
      <el-form-item :label="'自定义样式'" v-if="Object.keys(data.options).indexOf('otherClass')>=0">
        <el-input v-model="data.options.otherClass" size="small"></el-input>
      </el-form-item>
      <el-form-item :label="'表格宽度'" v-if="data.isTable">
        <el-input size="small" v-model="data.options.tableWidth"></el-input>
      </el-form-item>
      <el-form-item :label="'高度'" v-if="Object.keys(data.options).indexOf('height')>=0">
        <el-input v-model="data.options.height" size="small"></el-input>
      </el-form-item>

      <el-form-item :label="'大小'" v-if="Object.keys(data.options).indexOf('size')>=0">
        宽度
        <el-input size="small" style="width: 90px;" type="number" v-model.number="data.options.size.width"></el-input>
        高度
        <el-input size="small" style="width: 90px;" type="number" v-model.number="data.options.size.height"></el-input>
      </el-form-item>

      <el-form-item :label="'占位'"
                    v-if="Object.keys(data.options).indexOf('placeholder')>=0 && (data.type!='time' || data.type!='date')">
        <el-input size="small" v-model="data.options.placeholder"></el-input>
      </el-form-item>
      <el-form-item :label="'触发函数名'" v-if="data.type!='grid' && data.type!='table'">
        <el-input size="small" v-model="data.options.remoteFunc"></el-input>
      </el-form-item>
      <el-form-item :label="'是否固定列'" v-if="data.type!='grid' && data.type!='table'">
        <el-switch v-model="data.options.isFix">
        </el-switch>
      </el-form-item>
      <el-form-item :label="'合计'" v-if="data.isTable && data.type==='number'">
        <el-switch v-model="data.options.isTotal">
        </el-switch>
      </el-form-item>
      <el-form-item :label="'计算公式'" v-if="data.type==='number'">
        <popover ref="Popover" :table-data="data.modelkey__obj" :fuMal.sync="data.options.fuMal"
                 :fuMalkey.sync="data.options.fuMalkey"/>
      </el-form-item>
      <el-form-item :label="'布局'" v-if="Object.keys(data.options).indexOf('inline')>=0">
        <el-radio-group v-model="data.options.inline" size="small">
          <el-radio-button :label="false">块级</el-radio-button>
          <el-radio-button :label="true">行内</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="'显示输入框'" v-if="Object.keys(data.options).indexOf('showInput')>=0">
        <el-switch v-model="data.options.showInput"></el-switch>
      </el-form-item>
      <el-form-item :label="'最小值'" v-if="Object.keys(data.options).indexOf('min')>=0">
        <el-input-number size="small" v-model="data.options.min" :min="0" :max="100" :step="1"></el-input-number>
      </el-form-item>
      <el-form-item :label="'最大值'" v-if="Object.keys(data.options).indexOf('max')>=0">
        <el-input-number size="small" v-model="data.options.max" :min="0" :max="100" :step="1"></el-input-number>
      </el-form-item>
      <el-form-item :label="'步长'" v-if="Object.keys(data.options).indexOf('step')>=0">
        <el-input-number size="small" v-model="data.options.step" :min="0" :max="100" :step="1"></el-input-number>
      </el-form-item>
      <el-form-item :label="'多选'" v-if="data.type=='select' || data.type=='imgupload'">
        <el-switch size="small" v-model="data.options.multiple" @change="handleSelectMuliple"></el-switch>
      </el-form-item>
      <el-form-item :label="'多选'" v-if=" data.type=='selecTypeByApi'">
        <el-switch size="small" v-model="data.options.multiple"></el-switch>
      </el-form-item>

      <el-form-item :label="'新增'" v-if=" data.type=='table'">
        <el-switch size="small" v-model="data.options.btnadd"></el-switch>
      </el-form-item>
      <el-form-item :label="'删除'" v-if=" data.type=='table'">
        <el-switch size="small" v-model="data.options.btndel"></el-switch>
      </el-form-item>

      <el-form-item :label="'可搜索'" v-if="data.type=='select'">
        <el-switch v-model="data.options.filterable"></el-switch>
      </el-form-item>
      <el-form-item label="'允许半边'" v-if="Object.keys(data.options).indexOf('allowHalf')>=0">
        <el-switch v-model="data.options.allowHalf" size="small">
        </el-switch>
      </el-form-item>
      <el-form-item :label="'支持透明度选择'" v-if="Object.keys(data.options).indexOf('showAlpha')>=0">
        <el-switch v-model="data.options.showAlpha" size="small">
        </el-switch>
      </el-form-item>
      <el-form-item :label="'是否显示标签'" v-if="Object.keys(data.options).indexOf('showLabel')>=0">
        <el-switch v-model="data.options.showLabel" size="small">
        </el-switch>
      </el-form-item>
      <el-form-item :label="'选项'" v-if="Object.keys(data.options).indexOf('options')>=0">
        <!-- <el-radio-group v-model="data.options.remote" size="mini" style="margin-bottom:10px;">
          <el-radio-button :label="false">静态数据</el-radio-button>
          <el-radio-button :label="true">远端数据</el-radio-button>
        </el-radio-group> -->
        <!-- <template v-if="data.options.remote">
          <div>
            <el-input size="mini" style="" v-model="data.options.remoteFunc">
              <template slot="prepend">远端方法</template>
            </el-input>
            <el-input size="mini" style="" v-model="data.options.props.value">
              <template slot="prepend">值</template>
            </el-input>
            <el-input size="mini" style="" v-model="data.options.props.label">
              <template slot="prepend">标签</template>
            </el-input>
          </div>
        </template> -->
        <template>
          <!-- <template v-else> -->
          <template v-if="data.type=='radio' || (data.type=='select'&&!data.options.multiple)">
            <el-radio-group v-model="data.options.defaultValue" style="line-height: 40px;" size="small">
              <draggable tag="ul" :list="data.options.options"
                         v-bind="{group:{ name:'options'}, ghostClass: 'ghost',handle: '.drag-item'}"
                         handle=".drag-item">
                <li v-for="(item, index) in data.options.options" :key="index">
                  <el-radio :label="item.value" style="margin-right: 5px;">
                    <el-input :style="{'width': data.options.showLabel? '80px': '180px' }" size="mini"
                              v-model="item.value"></el-input>
                    <el-input style="width:80px;" size="mini" v-if="data.options.showLabel"
                              v-model="item.label"></el-input>
                    <!-- <input v-model="item.value"/> -->
                  </el-radio>
                  <i class="drag-item" style="font-size: 16px;margin: 0 5px;cursor: move;"><i class="el-icon-rank"
                                                                                              title="拖动"></i></i>
                  <el-button @click="handleOptionsRemove(index)" circle plain type="danger" size="mini" title="删除"
                             icon="el-icon-delete" style="padding: 4px;margin-left: 5px;"></el-button>

                </li>
              </draggable>

            </el-radio-group>
          </template>

          <template v-if="data.type=='checkbox' || (data.type=='select' && data.options.multiple)">
            <el-checkbox-group v-model="data.options.defaultValue" size="small">

              <draggable tag="ul" :list="data.options.options"
                         v-bind="{group:{ name:'options'}, ghostClass: 'ghost',handle: '.drag-item'}"
                         handle=".drag-item">
                <li v-for="(item, index) in data.options.options" :key="index">
                  <el-checkbox :label="item.value" style="margin-right: 5px;">
                    <el-input :style="{'width': data.options.showLabel? '90px': '180px' }" size="mini"
                              v-model="item.value"></el-input>
                    <el-input style="width:90px;" size="mini" v-if="data.options.showLabel"
                              v-model="item.label"></el-input>
                  </el-checkbox>
                  <i class="drag-item" style="font-size: 16px;margin: 0 5px;cursor: move;"><i class="el-icon-rank"
                                                                                              title="拖动"></i></i>
                  <el-button @click="handleOptionsRemove(index)" circle plain type="danger" title="删除" size="mini"
                             icon="el-icon-delete" style="padding: 4px;margin-left: 5px;"></el-button>

                </li>
              </draggable>
            </el-checkbox-group>
          </template>
          <div style="margin-left: 22px;">
            <el-button type="text" @click="handleAddOption">添加选项</el-button>
          </div>
        </template>

      </el-form-item>

      <!-- <el-form-item :label="'远端数据'" v-if="data.type=='cascader'">
        <div>
          <el-input size="mini" style="" v-model="data.options.remoteFunc">
            <template slot="prepend">远端方法</template>
          </el-input>
          <el-input size="mini" style="" v-model="data.options.props.value">
            <template slot="prepend">值</template>
          </el-input>
          <el-input size="mini" style="" v-model="data.options.props.label">
            <template slot="prepend">标签</template>
          </el-input>
          <el-input size="mini" style="" v-model="data.options.props.children">
            <template slot="prepend">子选项</template>
          </el-input>
        </div>
      </el-form-item> -->
      <el-form-item :label="'自定义值'" v-if="data.type=='switch'">
        <span>开</span>
        <el-input size="small" v-model="data.options.customizeopen"></el-input>
        <span>关</span>
        <el-input size="small" v-model="data.options.customizeclose"></el-input>
      </el-form-item>

      <el-form-item :label="'开关数据类型'" v-if="data.type=='switch'">
        <!-- <span>开关数据类型</span> -->
        <el-select v-model="data.options.customizeType" size="mini">
          <el-option value="string" :label="'字符串'"></el-option>
          <el-option value="boolean" :label="'布尔值'"></el-option>
          <el-option value="integer" :label="'整数'"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="'默认值'"
                    v-if="Object.keys(data.options).indexOf('defaultValue')>=0 && (data.type == 'textarea' || data.type == 'input' ||  data.type == 'text' || data.type=='rate' || data.type=='color' || data.type=='switch')">
        <el-input size="small" v-if="data.type=='textarea'" type="textarea" :rows="5"
                  v-model="data.options.defaultValue"></el-input>
        <el-input size="small" v-if="data.type=='input'" v-model="data.options.defaultValue"></el-input>
        <el-input size="small" v-if="data.type=='text'" v-model="data.options.defaultValue"></el-input>
        <el-rate size="small" v-if="data.type == 'rate'" style="display:inline-block;vertical-align: middle;"
                 :max="data.options.max" :allow-half="data.options.allowHalf"
                 v-model="data.options.defaultValue"></el-rate>
        <el-button size="small" type="text" v-if="data.type == 'rate'"
                   style="display:inline-block;vertical-align: middle;margin-left: 10px;"
                   @click="data.options.defaultValue=0">清空
        </el-button>
        <el-color-picker v-if="data.type == 'color'" v-model="data.options.defaultValue"
                         :show-alpha="data.options.showAlpha" size="small"></el-color-picker>
        <el-switch v-if="data.type=='switch'" v-model="data.options.defaultValue"
                   :active-value="data.options.customizeopen" :inactive-value="data.options.customizeclose"></el-switch>
      </el-form-item>

      <template v-if="data.type == 'time' || data.type == 'date'">
        <el-form-item :label="'显示类型'" v-if="data.type == 'date'">
          <el-select v-model="data.options.type" size="small">
            <el-option value="year"></el-option>
            <el-option value="month"></el-option>
            <el-option value="date"></el-option>
            <el-option value="dates"></el-option>
            <el-option value="week"></el-option>
            <el-option value="datetime"></el-option>
            <el-option value="datetimerange"></el-option>
            <el-option value="daterange"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="'是否为范围选择'" v-if="data.type == 'time'">
          <el-switch v-model="data.options.isRange" size="small">
          </el-switch>
        </el-form-item>
        <el-form-item :label="'是否获取时间戳'" v-if="data.type == 'date'">
          <el-switch v-model="data.options.timestamp" size="small">
          </el-switch>
        </el-form-item>
        <el-form-item :label="'占位'"
                      v-if="(!data.options.isRange && data.type == 'time') || (data.type != 'time' && data.options.type != 'datetimerange' && data.options.type != 'daterange')">
          <el-input size="small" v-model="data.options.placeholder"></el-input>
        </el-form-item>
        <el-form-item :label="'开始时间'"
                      v-if="(data.options.isRange) || data.options.type=='datetimerange' || data.options.type=='daterange'">
          <el-input size="small" v-model="data.options.startPlaceholder"></el-input>
        </el-form-item>
        <el-form-item :label="'结束时间'"
                      v-if="data.options.isRange || data.options.type=='datetimerange' || data.options.type=='daterange'">
          <el-input size="small" v-model="data.options.endPlaceholder"></el-input>
        </el-form-item>
        <el-form-item :label="'格式'">
          <el-input size="small" v-model="data.options.format"></el-input>
        </el-form-item>
        <el-form-item :label="'默认值'" v-if="data.type=='time' && Object.keys(data.options).indexOf('isRange')>=0">
          <el-time-picker key="1" style="width: 100%;" v-if="!data.options.isRange" v-model="data.options.defaultValue"
                          :arrowControl="data.options.arrowControl" :value-format="data.options.format" size="small">
          </el-time-picker>
          <el-time-picker key="2" v-if="data.options.isRange" style="width: 100%;" v-model="data.options.defaultValue"
                          is-range :arrowControl="data.options.arrowControl" :value-format="data.options.format"
                          size="small">
          </el-time-picker>
        </el-form-item>
      </template>

      <template v-if="data.type=='imgupload' || data.type=='formimgupload'">
        <el-form-item :label="'最大上传数'">
          <el-input size="small" type="number" v-model.number="data.options.length"></el-input>
        </el-form-item>
        <!-- <el-form-item :label="'使用七牛上传'">
          <el-switch size="small" v-model="data.options.isQiniu"></el-switch>
        </el-form-item> -->
        <!-- <template v-if="data.options.isQiniu">
          <el-form-item label="Domain" :required="true">
          <el-input v-model="data.options.domain"></el-input>
          </el-form-item>
          <el-form-item :label="'获取七牛Token方法'" :required="true">
            <el-input v-model="data.options.tokenFunc"></el-input>
          </el-form-item>
        </template> -->
        <template>
          <el-form-item :label="'图片上传地址'" :required="true">
            <el-input size="small" v-model="data.options.action"></el-input>
          </el-form-item>
        </template>
      </template>

      <template v-if="data.type=='blank'">
        <el-form-item :label="'绑定数据类型'">
          <el-select size="small" v-model="data.options.defaultType">
            <el-option value="String" :label="'字符串'"></el-option>
            <el-option value="Object" :label="'对象'"></el-option>
            <el-option value="Array" :label="'数组'"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template v-if="data.type=='blank'">
        <el-form-item :label="'是否显示表头'">
          <el-switch v-model="data.options.isTitle" active-color="#13ce66" inactive-color="#ff4949">
          </el-switch>
        </el-form-item>
      </template>
      <el-form-item :label="'选择对象ID'" v-if="data.type=='autoNew'">
        <el-input v-model="data.options.idKey" size="small"></el-input>
      </el-form-item>
      <el-form-item :label="'选择对象Name'" v-if="data.type=='autoNew'">
        <el-input v-model="data.options.nameKey" size="small"></el-input>
      </el-form-item>
      <el-form-item :label="'api名称'" v-if="data.type=='autoNew'">
        <el-input v-model="data.options.apiName" size="small"></el-input>
      </el-form-item>
      <el-form-item :label="'关联名称'" v-if="data.type=='autoNew'">
        <el-input v-model="data.options.relatedName" size="small"></el-input>
      </el-form-item>
      <el-form-item :label="'返回值'" v-if="data.type=='autoNew'">
        <group-item ref="GroupItem" :formData.sync="data.options.returnKey" :isRelation="false"></group-item>
      </el-form-item>
      <el-form-item :label="'查询条件'" v-if="data.type=='autoNew'">
        <group-item ref="GroupItem" :formData.sync="data.options.otherquery" :isRelation="true"></group-item>
      </el-form-item>
      <el-form-item :label="'选择对象ID'" v-if="data.type=='selecTypeByApi'">
        <el-input v-model="data.options.idKey" size="small"></el-input>
      </el-form-item>
      <el-form-item :label="'选择对象Name'" v-if="data.type=='selecTypeByApi'">
        <el-input v-model="data.options.nameKey" size="small"></el-input>
      </el-form-item>
      <el-form-item :label="'api名称'" v-if="data.type=='selecTypeByApi'">
        <el-input v-model="data.options.apiName" size="small"></el-input>
      </el-form-item>
      <el-form-item :label="'关联名称'" v-if="data.type=='selecTypeByApi'">
        <el-input v-model="data.options.relatedName" size="small"></el-input>
      </el-form-item>
      <!--  table的高度    -->
      <el-form-item :label="'子表单的高度'" v-if="data.type=='table'">
        <el-input v-model="data.options.tableHeight" size="small"></el-input>
      </el-form-item>
      <el-form-item :label="'查询条件'" v-if="data.type=='selecTypeByApi'">
        <group-item ref="GroupItem" :formData.sync="data.options.otherquery" :isRelation="true"></group-item>
      </el-form-item>
      <el-form-item :label="'请求方法'" v-if=" data.type=='selecTypeByApi'||data.type=='autoNew'">
        <el-input size="small" v-model="data.options.getDataMethod"></el-input>
      </el-form-item>
      <template v-if="data.type == 'grid'">
        <el-form-item :label="'栅格间隔'">
          <el-input size="small" type="number" v-model.number="data.options.gutter"></el-input>
        </el-form-item>
        <el-form-item :label="'列配置项'">
          <draggable tag="ul" :list="data.columns"
                     v-bind="{group:{ name:'options'}, ghostClass: 'ghost',handle: '.drag-item'}" handle=".drag-item">
            <li v-for="(item, index) in data.columns" :key="index">
              <i class="drag-item" style="font-size: 16px;margin: 0 5px;cursor: move;"><i class="el-icon-rank"
                                                                                          title="拖动"></i></i>
              <el-input :placeholder="'栅格值'" size="mini" style="width: 100px;" type="number"
                        v-model.number="item.span"></el-input>

              <el-button @click="handleOptionsRemove(index)" circle plain type="danger" size="mini"
                         icon="el-icon-delete" title="删除" style="padding: 4px;margin-left: 5px;"></el-button>

            </li>
          </draggable>
          <div style="margin-left: 22px;">
            <el-button size="small" type="text" @click="handleAddColumn">添加列</el-button>
          </div>
        </el-form-item>
        <el-form-item :label="'水平排列方式'">
          <el-select size="small" v-model="data.options.justify">
            <el-option value="start" :label="'左对齐'"></el-option>
            <el-option value="end" :label="'右对齐'"></el-option>
            <el-option value="center" :label="'居中'"></el-option>
            <el-option value="space-around" :label="'两侧间隔相等'"></el-option>
            <el-option value="space-between" :label="'两端对齐'"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="'垂直排列方式'">
          <el-select size="small" v-model="data.options.align">
            <el-option value="top" :label="'顶对齐'"></el-option>
            <el-option value="middle" :label="'居中'"></el-option>
            <el-option value="bottom" :label="'底对齐'"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template v-if="data.type == 'collapse'">
        <el-form-item :label="'是否手风琴模式'">
          <el-switch size="mini" v-model="data.options.accordion"></el-switch>
        </el-form-item>
        <el-form-item :label="'面板配置'">
          <draggable tag="ul" :list="data.columns"
                     v-bind="{group:{ name:'options'}, ghostClass: 'ghost',handle: '.drag-item'}" handle=".drag-item">
            <li v-for="(item, index) in data.columns" :key="index">
              <i class="drag-item" style="font-size: 16px;margin: 0 5px;cursor: move;"><i class="el-icon-rank"
                                                                                          title="拖动"></i></i>
              <el-row>
                <el-col>
                  <el-tag size="mini" style="margin-right:10px">唯一标识</el-tag>
                  <el-input :placeholder="'唯一标识'" size="mini" style="width: 150px;" v-model="item.name"></el-input>
                </el-col>
                <el-col>
                  <el-tag size="mini" style="margin-right:10px">面板标题</el-tag>
                  <el-input :placeholder="'面板标题'" size="mini" style="width: 150px;" v-model="item.title"></el-input>
                </el-col>
                <el-col>
                  <el-tag size="mini" style="margin-right:10px">是否禁用</el-tag>
                  <el-switch v-model="item.disabled">
                  </el-switch>
                  <el-button @click="handleOptionsRemove(index)" circle plain type="danger" size="mini"
                             icon="el-icon-delete" title="删除" style="padding: 4px;margin-left: 5px;"></el-button>
                </el-col>
              </el-row>

            </li>
          </draggable>
          <div style="margin-left: 22px;">
            <el-button size="small" type="text" @click="handleAddColumn">添加面板</el-button>
          </div>
        </el-form-item>
      </template>
      <template v-if="data.type != 'grid'&&data.type != 'collapse' && data.type !== 'text'">
        <el-form-item :label="'操作属性'">
          <el-checkbox size="small" v-model="data.options.readonly"
                       v-if="Object.keys(data.options).indexOf('readonly')>=0">只读
          </el-checkbox>
          <el-checkbox size="small" v-model="data.options.disabled"
                       v-if="Object.keys(data.options).indexOf('disabled')>=0">禁用
          </el-checkbox>
          <el-checkbox size="small" v-model="data.options.editable"
                       v-if="Object.keys(data.options).indexOf('editable')>=0">文本框可输
          </el-checkbox>
          <el-checkbox size="small" v-model="data.options.clearable"
                       v-if="Object.keys(data.options).indexOf('clearable')>=0">显示清除按钮
          </el-checkbox>
          <el-checkbox size="small" v-model="data.options.arrowControl"
                       v-if="Object.keys(data.options).indexOf('arrowControl')>=0">使用箭头进行时间选择
          </el-checkbox>
          <el-checkbox size="small" v-model="data.options.isDelete"
                       v-if="Object.keys(data.options).indexOf('isDelete')>=0">删除
          </el-checkbox>
          <el-checkbox size="small" v-model="data.options.isEdit" v-if="Object.keys(data.options).indexOf('isEdit')>=0">
            编辑
          </el-checkbox>

        </el-form-item>
        <el-form-item :label="'校验'">
          <div v-if="Object.keys(data.options).indexOf('required')>=0">
            <el-checkbox size="small" v-model="data.options.required">必填</el-checkbox>
          </div>
          <el-select v-if="Object.keys(data.options).indexOf('dataType')>=0" v-model="data.options.dataType"
                     size="mini">
            <el-option value="string" :label="'字符串'"></el-option>
            <el-option value="number" :label="'数字'"></el-option>
            <el-option value="boolean" :label="'布尔值'"></el-option>
            <el-option value="integer" :label="'整数'"></el-option>
            <el-option value="float" :label="'浮点数'"></el-option>
            <el-option value="url" :label="'URL地址'"></el-option>
            <el-option value="email" :label="'邮箱地址'"></el-option>
            <!-- <el-option value="hex" :label="'十六进制'"></el-option> -->
          </el-select>

          <div v-if="Object.keys(data.options).indexOf('pattern')>=0">
            <el-input size="mini" v-model.lazy="data.options.pattern" style=" width: 240px;"
                      :placeholder="'填写正则表达式'"></el-input>
          </div>
        </el-form-item>
      </template>
    </el-form>
  </div>
</template>

<script>import Popover from '@/components/Popover';
import Draggable from 'vuedraggable';
import GroupItem from '@/components/GroupItem';

export default {
  name: 'config',
  components: { /*  */
    Draggable, GroupItem, Popover
  },
  props: ['data', 'formkey'],
  data() {
    return {
      validator: {
        type: null,
        required: null,
        pattern: null,
        range: null,
        length: null
      }
    };
  },
  computed: {
    show() {
      // console.log(this.data)
      if (this.data && Object.keys(this.data).length > 0) {
        return true;
      }
      return false;
    }
  },
  methods: {
    handleOptionsRemove(index) {
      if (this.data.type === 'grid' || this.data.type === 'collapse') {
        this.data.columns.splice(index, 1);
      } else {
        this.data.options.options.splice(index, 1);
      }
    },
    handleAddOption() {
      if (this.data.options.showLabel) {
        this.data.options.options.push({
          value: '新选项',
          label: '新选项'
        });
      } else {
        this.data.options.options.push({
          value: '新选项'
        });
      }
    },
    handleAddColumn() {
      if (this.data.type === 'grid') {
        this.data.columns.push({
          span: '',
          list: []
        });
      } else if (this.data.type === 'collapse') {
        this.data.columns.push({
          title: '折叠面板',
          name: this.data.columns.length + '',
          disabled: false,
          list: []
        });
      }
    },
    generateRules() {
      this.data.rules = [];
      Object.keys(this.validator).forEach(key => {
        if (this.validator[key]) {
          this.data.rules.push(this.validator[key]);
        }
      });
    },
    handleSelectMuliple(value) {
      if (value) {
        if (this.data.options.defaultValue) {
          this.data.options.defaultValue = [this.data.options.defaultValue];
        } else {
          this.data.options.defaultValue = [];
        }
      } else {
        if (this.data.options.defaultValue.length > 0) {
          this.data.options.defaultValue = this.data.options.defaultValue[0];
        } else {
          this.data.options.defaultValue = '';
        }
      }
    },
    validateRequired(val) {
      if (val) {
        this.validator.required = { required: true, message: `${this.data.name}必须填写` };
      } else {
        this.validator.required = null;
      }
      this.$nextTick(() => {
        this.generateRules();
      });
    },
    validateDataType(val) {
      if (!this.show) {
        return false;
      }

      if (val) {
        this.validator.type = { type: val, message: `${this.data.name}格式不正确` };
      } else {
        this.validator.type = null;
      }
      this.generateRules();
    },
    valiatePattern(val) {
      if (!this.show) {
        return false;
      }
      if (val) {
        this.validator.pattern = { pattern: val, message: `${this.data.name}格式不匹配` };
      } else {
        this.validator.pattern = null;
      }
      this.generateRules();
    }
  },
  watch: {
    'data.options.isRange': function(val) {
      if (typeof val !== 'undefined') {
        if (val) {
          this.data.options.defaultValue = null;
        } else {
          if (Object.keys(this.data.options).indexOf('defaultValue') >= 0) {
            this.data.options.defaultValue = '';
          }
        }
      }
    },
    'data.options.required': function(val) {
      this.validateRequired(val);
    },
    'data.options.dataType': function(val) {
      this.validateDataType(val);
    },
    'data.options.pattern': function(val) {
      this.valiatePattern(val);
    },
    'data.name': function() {
      if (this.data.options) {
        this.validateRequired(this.data.options.required);
        this.validateDataType(this.data.options.dataType);
        this.valiatePattern(this.data.options.pattern);
      }
    }
  }
}; </script>
<style>
</style>
